import React from 'react';
import {
    CardContainer,
    ContentSection,
    TestimonialTitle,
    TestimonialDescription,
    ProfileSection,
    ProfileImage,
    ProfileInfo,
    ProfileName,
    ProfileBatch,
} from './styledComponents';

export interface TestimonialCardProps {
    name?: string;
    profileImageUrl?: string;
    batch?: string;
    testimonialTitle?: string;
    testimonialDescription?: string;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({
    name,
    profileImageUrl,
    batch,
    testimonialTitle,
    testimonialDescription,
}) => {
    return (
        <CardContainer className="testimonial-card">
            <ContentSection>
                {testimonialTitle && (
                    <TestimonialTitle className="testimonial-title">
                        {testimonialTitle}
                    </TestimonialTitle>
                )}
                {testimonialDescription && (
                    <TestimonialDescription className="testimonial-description">
                        {testimonialDescription}
                    </TestimonialDescription>
                )}
            </ContentSection>
            <ProfileSection>
                {profileImageUrl && (
                    <ProfileImage
                        className="testimonial-profile-image"
                        src={profileImageUrl}
                        alt={name || 'Profile'}
                    />
                )}
                <ProfileInfo>
                    {name && (
                        <ProfileName className="testimonial-profile-name">{name}</ProfileName>
                    )}
                    {batch && (
                        <ProfileBatch className="testimonial-profile-batch">
                            {batch}
                        </ProfileBatch>
                    )}
                </ProfileInfo>
            </ProfileSection>
        </CardContainer>
    );
};

export default TestimonialCard;
